import { connect } from 'react-redux'
import Toasts from './Toasts'
import toastsSelector from './toastsSelector'
import {
  remove as removeToast
} from 'store/redux/toasts'

export default connect(
  toastsSelector,
  {
    removeToast
  }
)(Toasts)

